'use client';

import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import type { NavLinkItem } from '@/navigation/links';

export default function NavLinkList({
  className,
  items,
  linkClassName,
}: {
  items: readonly NavLinkItem[];
  className?: string;
  linkClassName?: string;
}): React.ReactElement {
  return (
    <div className={classNames('flex gap-3', className)}>
      {items.map(item => (
        <Link key={item.id} href={item.href} className={linkClassName}>
          {item.label}
        </Link>
      ))}
    </div>
  );
}
